/* Staff (Call Quality) home — active surveys to run. */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { PhoneCall, ClipboardList, ArrowRight } from "lucide-react";

export default function StaffDashboard() {
  const [surveys, setSurveys] = useState(null);
  useEffect(() => {
    api.get("/surveys").then(({ data }) => setSurveys(data.surveys || [])).catch(() => setSurveys([]));
  }, []);
  return (
    <div className="space-y-6" data-testid="staff-dashboard">
      <div>
        <div className="text-xs font-mono uppercase tracking-[0.2em] text-neutral-500 mb-1">/ call quality</div>
        <h1 className="font-display font-bold text-3xl tracking-tighter inline-flex items-center gap-2">
          <PhoneCall size={26} /> Quality Surveys
        </h1>
        <p className="text-sm text-neutral-600 mt-1">Pick an active survey, call teachers from the list and note their answers.</p>
      </div>
      {surveys === null ? (
        <div className="text-neutral-500 text-sm">Loading…</div>
      ) : surveys.length === 0 ? (
        <div className="bg-white border border-dashed border-black/15 rounded-2xl p-12 text-center text-sm text-neutral-500">
          No active surveys right now — check back later.
        </div>
      ) : (
        <div className="grid sm:grid-cols-2 gap-4">
          {surveys.map((s) => (
            <Link
              key={s.id}
              to={`/surveys/run/${s.id}`}
              data-testid={`staff-survey-${s.id}`}
              className="bg-white border border-neutral-200 hover:border-[#0A0C10] rounded-xl p-5 transition-colors group"
            >
              <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-emerald-600 inline-flex items-center gap-1.5">
                <ClipboardList size={11} /> {s.status} · {s.questions?.length || 0} questions · {s.response_count || 0} responses
              </div>
              <div className="font-display font-bold text-lg mt-1.5">{s.title}</div>
              {s.description && <p className="text-xs text-neutral-500 mt-1 line-clamp-2">{s.description}</p>}
              <div className="mt-3 text-xs font-bold inline-flex items-center gap-1 group-hover:gap-2 transition-all">
                Start calling <ArrowRight size={12} />
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
